import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import R from 'ramda';

const ProductGalleryContainer = ({
  selectedGallery,
  currentBreakpoint,
  childComponent: ChildComponent,
  ...props
}) => (
  <ChildComponent
    selectedGallery={selectedGallery}
    currentBreakpoint={currentBreakpoint}
    {...props}
  />
);

const getSelectedGallery = ({ productSwatch, content }) => (
  R.compose(
    R.defaultTo({}),
    R.find(({ sku }) => sku === productSwatch.selectedSKU),
    R.path(['productGallery']),
  )(content)
);

const mapStateToProps = ({ productSwatch, content, breakpoints }) => {
  const selectedGallery = getSelectedGallery({ productSwatch, content });

  return ({
    selectedGallery,
    currentBreakpoint: breakpoints.current,
  });
};

ProductGalleryContainer.propTypes = {
  childComponent: PropTypes.func.isRequired,
  selectedGallery: PropTypes.shape({
    images: PropTypes.array.isRequired,
    sku: PropTypes.string.isRequired,
  }).isRequired,
  currentBreakpoint: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(ProductGalleryContainer);
